import controller from './ElementComponentizerCtrl';

export default {
    controller,
    bindings: {
        element: '<'
    }
};